/**
 *
 * TrendsWrapper
 *
 */

import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import { makeSelectAuth } from 'containers/Auth/selectors';
import {
  makeSelectAllowSignIn,
  makeSelectClientDetails,
} from 'containers/Main/selectors';
import OverallTrendsAnonymous from './OverallTrendsAnonymous';
import OverallTrendsSignedIn from './OverallTrendsSignedIn';
import RegularTrendsSignedIn from './RegularTrendsSignedIn';

function TrendsWrapper(props) {
  const auth = useSelector(makeSelectAuth());
  const isNewLogin = useRef(auth.isEmpty);
  const allowSignIn = useSelector(makeSelectAllowSignIn());
  const clientDetails = useSelector(makeSelectClientDetails());

  if (
    !allowSignIn ||
    _get(clientDetails, 'metadata.hideEmailMyResultsButton', false)
  )
    return null;

  if (props.type === 'overall') {
    if (auth.isEmpty) return <OverallTrendsAnonymous {...props} />;
    return <OverallTrendsSignedIn {...props} isNewLogin={isNewLogin.current} />;
  }

  if (props.type === 'regular' && !auth.isEmpty) {
    return <RegularTrendsSignedIn {...props} />;
  }

  return null;
}

export default TrendsWrapper;
